import React from 'react';
import { useSelector } from 'react-redux';
import { selectTier2PieChartData } from '../../../../../../slices/teamStatsSlice';
import DistributionPieCard from './DistributionPieCard';

const Tier2 = () => {
  const pieChartData = useSelector(selectTier2PieChartData)
  
  return (
    <DistributionPieCard title="Tier 2 Investigations" pieChartData={pieChartData} />
  )
}

export default Tier2;
